import {
  GET_ALL_ADR_ADMIN_FORMS,
  GET_ALL_ADR_FORM_FIELDS,
  GET_FIELDS_BY_ID,
} from '../../types'

const INITIAL_STATE = {
  getAllFormSections: [],
  getAllFormSectionFields: [],
  getOnefieds: [],
}

const fieldManageReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_ADR_ADMIN_FORMS:
      return {
        ...state,
        getAllFormSections: payload.data,
        loader: false,
      }

    case GET_ALL_ADR_FORM_FIELDS:
      return {
        ...state,
        getAllFormSectionFields: payload.data,
        loader: false,
      }
    case GET_FIELDS_BY_ID:
      return {
        ...state,
        getOnefieds: payload.data,
        loader: false,
      }

    default:
      return state
  }
}

export default fieldManageReducer
